// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaRegUser } from "react-icons/fa";
// import { BsCart3 } from "react-icons/bs";
// import { FaRegHeart } from "react-icons/fa";
// import "../../Styles/Navbar.css";
// import img1 from "./eesouq.png";
// import img2 from "./citychoice.png";
// import api from "../../api.js";
// import useDebounce from "./UseDebounce.jsx";
// import searchIcon from "./search-i.png";

// const Navbar = ({ cartCount }) => {
//   const navigate = useNavigate();
//   const [currentTextIndex, setCurrentTextIndex] = useState(0);
//   const texts = ["Eesouq", "Amazing Deals!"];
//   const [hovered, setHovered] = useState(false);
//   const userId = localStorage.getItem("accessToken");

//   const [searchTerm, setSearchTerm] = useState("");
//   const [results, setResults] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [userIcon, setUserIcon] = useState(false);
//   const [cartItemsCount, setCartItemsCount] = useState(cartCount || 0);

//   console.log("cartCount : ",cartCount)

//   const debouncedSearchTerm = useDebounce(searchTerm, 30); // 300ms delay

//   useEffect(() => {
//     if (debouncedSearchTerm.length > 0) {
//       handleSearch(debouncedSearchTerm);
//     } else {
//       setResults([]);
//     }
//   }, [debouncedSearchTerm]);

//    useEffect(() => {
//     setCartItemsCount(cartCount);
//   }, [cartCount]);

//   useEffect(() => {
//     const fetchCount = async () => {
//       try {
//         const res = await api.get(
//           `/user_api/cart/count-cart-wishlist-items?access_token=${JSON.parse(
//             userId
//           )}`
//         );
//         if (res.data.status === "success") {
//           setCartItemsCount(res.data.total_cart_items);
//         }
//         console.log("total cart :", res);
//       } catch (error) {
//         console.error("Search failed:", error);
//       }
//     };
//     fetchCount();
//   }, []);

//   const handleSearch = async () => {
//     if (!debouncedSearchTerm.trim()) return;

//     try {
//       const res = await api.get("/user_api/product/search-product", {
//         params: { keyword: debouncedSearchTerm },
//       });

//       if (res.data.status === "success") {
//         setResults(res.data.product_list);
//         setShowDropdown(true);
//       } else {
//         setResults([]);
//         setShowDropdown(false);
//       }
//     } catch (error) {
//       console.error("Search failed:", error);
//       setResults([]);
//       setShowDropdown(false);
//     }
//   };

//   const handleResultClick = (productUrl) => {
//     navigate(`/Product_details_final/${productUrl}`);
//     window.location.reload();
//     setShowDropdown(false);
//     setSearchTerm("");
//   };

//   const handleLogout = async () => {
//     localStorage.removeItem("accessToken");
//     navigate("/login");
//   };
//   const handleCartClick = (e) => {
//     e.preventDefault();
//     if (userId) {
//       navigate("/cart");
//     } else {
//       navigate("/login");
//     }
//   };
//   const handleWishClick = (e) => {
//     e.preventDefault();
//     if (userId) {
//       navigate("/wishlistHome");
//     } else {
//       navigate("/login");
//     }
//   };

//   const targetRef = useRef(null);

//   const scrollDown = () => {
//     window.scrollTo({
//       top: document.documentElement.scrollHeight,
//       behavior: "smooth",
//     });
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [texts.length]);

//   useEffect(() => {
//     searchTerm === "" ? setShowDropdown(false) : setShowDropdown(true);
//   }, [searchTerm]);

//   return (
//     <div style={{ display: "flex", flexDirection: "column" }}>
//       <div className="header1">
//         <div className="rotating-text">
//           {texts.map((text, index) => (
//             <span
//               key={index}
//               className={index === currentTextIndex ? "active" : ""}
//             >
//               {text}
//             </span>
//           ))}
//         </div>

//         <nav
//           className="nav-links"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "10px",
//             fontSize: "1 rem",
//           }}
//         >
//           <a onClick={scrollDown}>Get App</a>
//           <a href="/contact-us">Contact Us</a>
//           <a href="/contact-us">Help</a>
//         </nav>
//       </div>
//       <header className="header logo-align--center" data-sticky-header>
//         <div className="header-mobile">
//           <div className="header-mobiletop" data-sticky-mheader>
//             <div
//               className="row align-items-center"
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 padding: "5px",
//               }}
//             >
//               <div
//                 className="col-6 logo-container"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "flex-start",
//                   width: "78%",
//                 }}
//               >
//                 {/* <a
//                     href="/"
//                     className="header-logo__link"
//                     data-header-logo-link
//                   > */}
//                 <div
//                   className="header-logo-image-container"
//                   style={{ display: "flex", gap: "10px" }}
//                 >
//                   <a
//                     href="/"
//                     className="fw-bold fs-3"
//                     style={{
//                       width: "60%",
//                       display: "flex",
//                       alignItems: "center",
//                     }}
//                   >
//                     <img src={img1} alt="Site Logo" />
//                   </a>
//                   <div className="banner-wrapper fade-in-slide">
//                     <a
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="banner-link"
//                     >
//                       <img
//                         src={img2}
//                         alt="Best of Beauty Banner"
//                         className="banner-image"
//                         loading="lazy"
//                       />
//                     </a>
//                   </div>
//                 </div>
//                 {/* </a> */}
//               </div>
//               <div
//                 className="col-3 cart-container "
//                 style={{
//                   display: "flex",
//                   justifyContent: "flex-end",

//                   borderRadius: "10px",
//                   width: "20%",
//                   padding: "5px 10px",
//                 }}
//               >
//                 <div
//                   className="cart-button "
//                   onClick={() => setUserIcon(!userIcon)}
//                 >
//                   <div className="icon">
//                     <svg width={20} height={20}>
//                       <FaRegUser size={20} />
//                     </svg>
//                   </div>

//                   {userIcon && (
//                     <div
//                       style={{
//                         position: "absolute",
//                         width: "fit-content",
//                         backgroundColor: "gray",
//                         padding: "5px",
//                         borderRadius: "0px 10px 10px 10px",
//                         color: "white",
//                         top: "40px",
//                         zIndex: 1000,
//                         fontSize: "16px",
//                         boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
//                       }}
//                       onClick={() => {
//                         userId
//                           ? navigate("/profile/update")
//                           : navigate("/login");
//                       }}
//                     >
//                       {userId ? "Profile" : "Login or Sign up"}
//                     </div>
//                   )}
//                 </div>
//                 <div className="cart-button " onClick={handleWishClick}>
//                   <div className="icon">
//                     <svg width={20} height={20}>
//                       <use href="#icon-shopping-cart" />
//                       <FaRegHeart size={20} />
//                     </svg>
//                   </div>
//                 </div>
//                 <div className="cart-button " onClick={handleCartClick}>
//                   <div className="icon">
//                     <svg width={20} height={20}>
//                       <use href="#icon-shopping-cart" />
//                       <BsCart3 size={20} />
//                     </svg>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="header-mobilebottom ">
//             <div className="container">
//               <div className="search-info-content ">
//                 {/* snippet location forms_search */}
//                 <form
//                   className="wb-searchpro"
//                   onSubmit={handleSearch}
//                   action=""
//                 >
//                   <fieldset
//                     className="form-fieldset"
//                     style={{
//                       backgroundColor: "white",
//                       border: "1px solid black",
//                       borderRadius: "30px",
//                     }}
//                   >
//                     <div className="input-group">
//                       <input
//                         className="form-control form-input"
//                         name="search_query"
//                         data-error-message="Search field cannot be empty."
//                         placeholder="Search the store"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={{
//                           borderRadius: "30px",
//                           outline: "none ",
//                           boxShadow: "none",
//                         }}
//                       />
//                       <div
//                         className="input-group-append"
//                         style={{
//                           borderRadius: "30px",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <button
//                           className="btn "
//                           type="submit"
//                           onClick={handleSearch}
//                         >
//                           <img
//                             src={searchIcon}
//                             style={{
//                               width: "23px",
//                             }}
//                           />
//                         </button>
//                       </div>
//                     </div>
//                   </fieldset>
//                 </form>
//                 {showDropdown && results.length > 0 ? (
//                   <div
//                     className="search-dropdown"
//                     style={{
//                       position: "absolute",
//                       top: "160px",
//                       left: 0,
//                       right: 0,
//                       background: "white",
//                       border: "1px solid #ccc",
//                       borderRadius: "10px",
//                       maxHeight: "400px",
//                       overflowY: "auto",
//                       zIndex: 1000,
//                     }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "flex-end",
//                         padding: "10px",
//                         cursor: "pointer",
//                         fontWeight: "bold",
//                         borderRadius: "20px",
//                       }}
//                       onClick={() => setShowDropdown(false)}
//                     >
//                       close
//                     </div>
//                     {results.map((item) => (
//                       <div
//                         key={item.id}
//                         onClick={() => handleResultClick(item.product_url)}
//                         style={{
//                           padding: "10px",
//                           cursor: "pointer",
//                           borderBottom: "1px solid #eee",
//                           display: "flex",
//                           alignItems: "center",
//                         }}
//                       >
//                         <img
//                           src={item.product_image_path?.[0]?.real_image_path}
//                           alt={item.product_name}
//                           style={{
//                             width: "50px",
//                             height: "50px",
//                             objectFit: "contain",
//                             marginRight: "10px",
//                           }}
//                         />
//                         <span style={{ flex: 1 }}>{item.product_name}</span>
//                         <span style={{ color: "#e63946", fontWeight: "bold" }}>
//                           AED {item.selling_price}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   ""
//                 )}
//                 <section
//                   className="quickSearchResults dropdown"
//                   data-bind="html: results"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="header-center">
//           <div className="container">
//             <div className="row align-items-center justyfy-content-center">
//               <div className="col-xl-2 col-lg-3 col-md-3 col-8 logo-container">
//                 {/* <a href="/" className="header-logo__link" data-header-logo-link> */}
//                 <div
//                   className="header-logo-image-container"
//                   style={{ display: "flex", gap: "10px" }}
//                 >
//                   <a
//                     href="/"
//                     className="fw-bold fs-3"
//                     style={{
//                       width: "60%",
//                       display: "flex",
//                       alignItems: "center",
//                     }}
//                   >
//                     <img src={img1} alt="Site Logo" />
//                   </a>
//                   <div
//                     className="banner-wrapper fade-in-slide"
//                     style={{ display: "flex", gap: "1px" }}
//                   >
//                     <a
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="banner-link"
//                     >
//                       <img
//                         src={img2}
//                         alt="Best of Beauty Banner"
//                         className="banner-image"
//                         loading="lazy"
//                       />
//                     </a>
//                   </div>
//                 </div>
//                 {/* </a> */}
//               </div>
//               <div className="header-center-left col-xl-6 col-lg-5 col-md-5 col-4">
//                 {/* snippet location forms_search */}
//                 <form className="wb-formSearch" onSubmit={handleSearch}>
//                   <fieldset className="form-fieldset">
//                     <div className="input-group">
//                       <input
//                         id="ls-search"
//                         className="form-control form-input"
//                         name="search_query"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         placeholder="Search by Product"
//                         style={{
//                           borderTopLeftRadius: "30px",
//                           borderBottomLeftRadius: "30px",
//                         }}
//                       />
//                       <div
//                         className="input-group-append"
//                         style={{
//                           backgroundColor: "white",
//                           borderTopRightRadius: "30px",
//                           borderBottomRightRadius: "30px",
//                         }}
//                       >
//                         <div
//                           className=""
//                           style={{
//                             backgroundColor: "white",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             paddingRight: "20px",
//                             borderRadius: "20px",
//                           }}
//                         >
//                           <img src={searchIcon} style={{ width: "23px" }} />
//                         </div>
//                       </div>
//                     </div>
//                   </fieldset>
//                 </form>
//                 {showDropdown && results.length > 0 && (
//                   <div
//                     className="search-dropdown"
//                     style={{
//                       position: "absolute",
//                       top: "100%",
//                       left: 0,
//                       right: 0,
//                       background: "white",
//                       border: "1px solid #ccc",
//                       borderRadius: "10px",
//                       maxHeight: "400px",
//                       overflowY: "auto",
//                       zIndex: 1000,
//                     }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "flex-end",
//                         padding: "10px",
//                         cursor: "pointer",
//                         fontWeight: "bold",
//                       }}
//                       onClick={() => setShowDropdown(false)}
//                     >
//                       close
//                     </div>
//                     {results.map((item) => (
//                       <div
//                         key={item.id}
//                         onClick={() => handleResultClick(item.product_url)}
//                         style={{
//                           padding: "10px",
//                           cursor: "pointer",
//                           borderBottom: "1px solid #eee",
//                           display: "flex",
//                           alignItems: "center",
//                         }}
//                       >
//                         <img
//                           src={item.product_image_path?.[0]?.real_image_path}
//                           alt={item.product_name}
//                           style={{
//                             width: "50px",
//                             height: "50px",
//                             objectFit: "contain",
//                             marginRight: "10px",
//                           }}
//                         />
//                         <span style={{ flex: 1 }}>{item.product_name}</span>
//                         <span style={{ color: "#e63946", fontWeight: "bold" }}>
//                           AED {item.selling_price}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 <section
//                   className="dropdown dropdown--quickSearch quickSearchResults "
//                   data-bind="html: results"
//                 ></section>
//               </div>
//               <div className=" header-center-right  " style={{ width: "30%" }}>
//                 <ul className="navUser-section ">
//                   <li
//                     className="navUser-item signinSelection"
//                     onMouseEnter={() => setHovered(true)}
//                     onMouseLeave={() => setHovered(false)}
//                     style={{
//                       position: "relative",
//                       borderRight: "1px solid black",
//                       paddingTop: "3px",
//                     }}
//                   >
//                     <div
//                       className="navUser-action"
//                       style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         cursor: "pointer",
//                         position: "relative",
//                       }}
//                     >
//                       <div
//                         className="cart-button"
//                         style={{ margin: "0px", position: "relative" }}
//                       >
//                         <FaRegUser size={16} />
                       
//                       </div>
//                       <span
//                         className="cart-text cart-text--account"
//                         style={{ textAlign: "center" }}
//                       >
//                         My Account
//                       </span>
//                     </div>

//                     {hovered && (
//                       <ul
//                         className="dropdown-menu"
//                         style={{
//                           position: "absolute",
//                           top: "100%",
//                           left: 0,
//                           backgroundColor: "#fff",
//                           boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
//                           padding: "10px 0",
//                           zIndex: 99999,
//                           minWidth: "140px",
//                           borderRadius: "6px",
//                         }}
//                       >
//                         {userId ? (
//                           <>
//                             <li
//                               className="dropdown-menu-item"
//                               style={{ padding: "8px 15px", cursor: "pointer" }}
//                               onClick={() => navigate("/profile/update")}
//                             >
//                               Profile
//                             </li>
//                             <li
//                               className="dropdown-menu-item"
//                               style={{ padding: "8px 15px", cursor: "pointer" }}
//                               onClick={handleLogout}
//                             >
//                               Logout
//                             </li>
//                           </>
//                         ) : (
//                           <>
//                             <li
//                               className="dropdown-menu-item"
//                               style={{ padding: "8px 15px", cursor: "pointer" }}
//                               onClick={() => navigate("/login")}
//                             >
//                               Login or Signup
//                             </li>
//                           </>
//                         )}
//                       </ul>
//                     )}
//                   </li>
//                   <li
//                     className="navUser-item header-center__cart"
//                     style={{ borderRight: "1px solid black" }}
//                   >
//                     <a
//                       className="navUser-action cart-button--primary"
//                       data-cart-preview
//                       data-dropdown="cart-preview-dropdown"
//                       onClick={handleWishClick}
//                       href="#"
//                       aria-label="Cart with 0 items"
//                       style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <div
//                         className="cart-button"
//                         style={{
//                           display: "flex",
//                           margin: "0px",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <svg width={16} height={16}>
//                           <use href="#icon-shopping-cart" />
//                           <FaRegHeart size={16} />
//                         </svg>
//                       </div>
//                       <p
//                         className="cart-text text-shopping-cart"
//                         style={{ textAlign: "center", color: "#93979c" }}
//                       >
//                         Wishlist
//                       </p>
//                     </a>
//                     <div
//                       className="dropdown-menu"
//                       id="cart-preview-dropdown"
//                       data-dropdown-content
//                       aria-hidden="true"
//                     />
//                   </li>
//                   <li className="navUser-item header-center__cart">
//                     <a
//                       className="navUser-action cart-button--primary"
//                       data-cart-preview
//                       data-dropdown="cart-preview-dropdown"
//                       onClick={handleCartClick}
//                       href="#"
//                       aria-label="Cart with 0 items"
//                       style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <div className="cart-button" style={{ margin: "0px",position:"relative" }}>
//                         <svg width={16} height={16}>
//                           <use href="#icon-shopping-cart" />
//                           <BsCart3 size={16} />
//                         </svg>
//                          {cartItemsCount > 0 && (
//                           <span
//                             style={{
//                               position: "absolute",
//                               top: "-1px",
//                               right: "-2px",
//                               backgroundColor: "red",
//                               color: "white",
//                               borderRadius: "50%",
//                               width: "20px",
//                               height: "20px",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               fontSize: "13px",
//                               fontWeight: "bold",
//                             }}
//                           >
//                             {cartItemsCount}
//                           </span>
//                         )}
//                       </div>
//                       <p
//                         className="cart-text text-shopping-cart"
//                         style={{ textAlign: "center", color: "#93979c" }}
//                       >
//                         My Cart
//                       </p>
//                     </a>
//                     <div
//                       className="dropdown-menu"
//                       id="cart-preview-dropdown"
//                       data-dropdown-content
//                       aria-hidden="true"
//                     />
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//     </div>
//   );
// };

// export default Navbar;


import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { BsCart3 } from "react-icons/bs";
import { FaRegHeart } from "react-icons/fa";
import "../../Styles/Navbar.css";
import img1 from "./eesouq.png";
import img2 from "./citychoice.png";
import api from "../../api.js";
import useDebounce from "./UseDebounce.jsx";
import searchIcon from "./search-i.png";

const Navbar = ({ cartCount }) => {
  const navigate = useNavigate();
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const texts = ["Eesouq", "Amazing Deals!"];
  const [hovered, setHovered] = useState(false);
  const userId = localStorage.getItem("accessToken");

  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userIcon, setUserIcon] = useState(false);
  const [cartItemsCount, setCartItemsCount] = useState(cartCount || 0);

  console.log("cartCount : ",cartCount)

  const debouncedSearchTerm = useDebounce(searchTerm, 30); // 300ms delay

  useEffect(() => {
    if (debouncedSearchTerm.length > 0) {
      handleSearch(debouncedSearchTerm);
    } else {
      setResults([]);
    }
  }, [debouncedSearchTerm]);

   useEffect(() => {
    setCartItemsCount(cartCount);
  }, [cartCount]);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await api.get(
          `/user_api/cart/count-cart-wishlist-items?access_token=${JSON.parse(
            userId
          )}`
        );
        if (res.data.status === "success") {
          setCartItemsCount(res.data.total_cart_items);
        }
        console.log("total cart :", res);
      } catch (error) {
        console.error("Search failed:", error);
      }
    };
    fetchCount();
  }, []);

  const handleSearch = async () => {
    if (!debouncedSearchTerm.trim()) return;

    try {
      const res = await api.get("/user_api/product/search-product", {
        params: { keyword: debouncedSearchTerm },
      });

      if (res.data.status === "success") {
        setResults(res.data.product_list);
        setShowDropdown(true);
      } else {
        setResults([]);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error("Search failed:", error);
      setResults([]);
      setShowDropdown(false);
    }
  };

  const handleResultClick = (productUrl) => {
    navigate(`/Product_details_final/${productUrl}`);
    window.location.reload();
    setShowDropdown(false);
    setSearchTerm("");
  };

  const handleLogout = async () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };
  const handleCartClick = (e) => {
    e.preventDefault();
    if (userId) {
      navigate("/cart");
    } else {
      navigate("/login");
    }
  };
  const handleWishClick = (e) => {
    e.preventDefault();
    if (userId) {
      navigate("/wishlistHome");
    } else {
      navigate("/login");
    }
  };

  const targetRef = useRef(null);

  const scrollDown = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [texts.length]);

  useEffect(() => {
    searchTerm === "" ? setShowDropdown(false) : setShowDropdown(true);
  }, [searchTerm]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="header1">
        <div className="rotating-text">
          {texts.map((text, index) => (
            <span
              key={index}
              className={index === currentTextIndex ? "active" : ""}
            >
              {text}
            </span>
          ))}
        </div>

        <nav
          className="nav-links"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            fontSize: "1 rem",
          }}
        >
          <a onClick={scrollDown}>Get App</a>
          <a href="/contact-us">Contact Us</a>
          <a href="/contact-us">Help</a>
        </nav>
      </div>
      <header className="header logo-align--center" data-sticky-header>
        <div className="header-mobile">
          <div className="header-mobiletop" data-sticky-mheader>
            <div
              className="row align-items-center"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "5px",
              }}
            >
              <div
                className="col-6 logo-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
            
                }}
              >
                
                <div
                  className="header-logo-image-container"
                  style={{ display: "flex", gap: "10px" }}
                >
                  <a
                    href="/"
                    className="fw-bold fs-3"
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={img1} alt="Site Logo" />
                  </a>
                  <div className="banner-wrapper fade-in-slide">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="banner-link"
                    >
                      <img
                        src={img2}
                        alt="Best of Beauty Banner"
                        className="banner-image"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
               
              </div>
              <div
                className="col-3 cart-container "
                style={{
                  display: "flex",
                  justifyContent: "flex-end",

                  borderRadius: "10px",
                  width: "20%",
                  padding: "5px 10px",
                }}
              >
                <div
                  className="cart-button "
                  onClick={() => setUserIcon(!userIcon)}
                >
                  <div className="icon">
                    <svg width={20} height={20}>
                      <FaRegUser size={20} />
                    </svg>
                  </div>

                  {userIcon && (
                    <div
                      style={{
                        position: "absolute",
                        width: "fit-content",
                        backgroundColor: "gray",
                        padding: "5px",
                        borderRadius: "0px 10px 10px 10px",
                        color: "white",
                        top: "40px",
                        zIndex: 1000,
                        fontSize: "16px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                      }}
                      onClick={() => {
                        userId
                          ? navigate("/profile/update")
                          : navigate("/login");
                      }}
                    >
                      {userId ? "Profile" : "Login or Sign up"}
                    </div>
                  )}
                </div>
                <div className="cart-button " onClick={handleWishClick}>
                  <div className="icon">
                    <svg width={20} height={20}>
                      <use href="#icon-shopping-cart" />
                      <FaRegHeart size={20} />
                    </svg>
                  </div>
                </div>
                <div className="cart-button " onClick={handleCartClick}>
                  <div className="icon">
                    <svg width={20} height={20}>
                      <use href="#icon-shopping-cart" />
                      <BsCart3 size={20} />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-mobilebottom ">
            <div className="container">
              <div className="search-info-content ">
              
                <form
                  className="wb-searchpro"
                  onSubmit={handleSearch}
                  action=""
                >
                  <fieldset
                    className="form-fieldset"
                    style={{
                      backgroundColor: "white",
                      border: "1px solid black",
                      borderRadius: "30px",
                    }}
                  >
                    <div className="input-group">
                      <input
                        className="form-control form-input"
                        name="search_query"
                        data-error-message="Search field cannot be empty."
                        placeholder="Search the store"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          borderRadius: "30px",
                          outline: "none ",
                          boxShadow: "none",
                        }}
                      />
                      <div
                        className="input-group-append"
                        style={{
                          borderRadius: "30px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          className="btn "
                          type="submit"
                          onClick={handleSearch}
                        >
                          <img
                            src={searchIcon}
                            style={{
                              width: "23px",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </form>
                {showDropdown && results.length > 0 ? (
                  <div
                    className="search-dropdown"
                    style={{
                      position: "absolute",
                      top: "160px",
                      left: 0,
                      right: 0,
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "10px",
                      maxHeight: "400px",
                      overflowY: "auto",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        borderRadius: "20px",
                      }}
                      onClick={() => setShowDropdown(false)}
                    >
                      close
                    </div>
                    {results.map((item) => (
                      <div
                        key={item.id}
                        onClick={() => handleResultClick(item.product_url)}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={item.product_image_path?.[0]?.real_image_path}
                          alt={item.product_name}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                            marginRight: "10px",
                          }}
                        />
                        <span style={{ flex: 1 }}>{item.product_name}</span>
                        <span style={{ color: "#e63946", fontWeight: "bold" }}>
                          AED {item.selling_price}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  ""
                )}
                <section
                  className="quickSearchResults dropdown"
                  data-bind="html: results"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="header-center">
          <div className="container">
            <div className="row align-items-center justyfy-content-center">
              <div className="logo-container" style={{width:"30%"}}>
              
                <div
                  className="header-logo-image-container"
                  style={{ display: "flex", gap: "10px" }}
                >
                  <a
                    href="/"
                    className="fw-bold fs-3"
                    style={{
                      width: "50%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={img1} alt="Site Logo" />
                  </a>
                  <div
                    className="banner-wrapper fade-in-slide"
                    style={{ display: "flex", gap: "1px" }}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="banner-link"
                    >
                      <img
                        src={img2}
                        alt="Best of Beauty Banner"
                        className="banner-image"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
              
              </div>
              <div className="" style={{width:"40%"}}>
              
                <form className="wb-formSearch" onSubmit={handleSearch}>
                  <fieldset className="form-fieldset">
                    <div className="input-group">
                      <input
                        id="ls-search"
                        className="form-control form-input"
                        name="search_query"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search by Product"
                        style={{
                          borderTopLeftRadius: "30px",
                          borderBottomLeftRadius: "30px",
                        }}
                      />
                      <div
                        className="input-group-append"
                        style={{
                          backgroundColor: "white",
                          borderTopRightRadius: "30px",
                          borderBottomRightRadius: "30px",
                        }}
                      >
                        <div
                          className=""
                          style={{
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingRight: "20px",
                            borderRadius: "20px",
                          }}
                        >
                          <img src={searchIcon} style={{ width: "23px" }} />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
                {showDropdown && results.length > 0 && (
                  <div
                    className="search-dropdown"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "10px",
                      maxHeight: "400px",
                      overflowY: "auto",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      onClick={() => setShowDropdown(false)}
                    >
                      close
                    </div>
                    {results.map((item) => (
                      <div
                        key={item.id}
                        onClick={() => handleResultClick(item.product_url)}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={item.product_image_path?.[0]?.real_image_path}
                          alt={item.product_name}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                            marginRight: "10px",
                          }}
                        />
                        <span style={{ flex: 1 }}>{item.product_name}</span>
                        <span style={{ color: "#e63946", fontWeight: "bold" }}>
                          AED {item.selling_price}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                <section
                  className="dropdown dropdown--quickSearch quickSearchResults "
                  data-bind="html: results"
                ></section>
              </div>
              <div className=" header-center-right  " style={{ width: "30%" }}>
                <ul className="navUser-section ">
                  <li
                    className="navUser-item signinSelection"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    style={{
                      position: "relative",
                      borderRight: "1px solid black",
                      paddingTop: "3px",
                    }}
                  >
                    <div
                      className="navUser-action"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        position: "relative",
                      }}
                    >
                      <div
                        className="cart-button"
                        style={{ margin: "0px", position: "relative" }}
                      >
                        <FaRegUser size={16} />
                       
                      </div>
                      <span
                        className="cart-text cart-text--account"
                        style={{ textAlign: "center" }}
                      >
                        My Account
                      </span>
                    </div>

                    {hovered && (
                      <ul
                        className="dropdown-menu"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                          padding: "10px 0",
                          zIndex: 99999,
                          minWidth: "140px",
                          borderRadius: "6px",
                        }}
                      >
                        {userId ? (
                          <>
                            <li
                              className="dropdown-menu-item"
                              style={{ padding: "8px 15px", cursor: "pointer" }}
                              onClick={() => navigate("/profile/update")}
                            >
                              Profile
                            </li>
                            <li
                              className="dropdown-menu-item"
                              style={{ padding: "8px 15px", cursor: "pointer" }}
                              onClick={handleLogout}
                            >
                              Logout
                            </li>
                          </>
                        ) : (
                          <>
                            <li
                              className="dropdown-menu-item"
                              style={{ padding: "8px 15px", cursor: "pointer" }}
                              onClick={() => navigate("/login")}
                            >
                              Login or Signup
                            </li>
                          </>
                        )}
                      </ul>
                    )}
                  </li>
                  <li
                    className="navUser-item header-center__cart"
                    style={{ borderRight: "1px solid black" }}
                  >
                    <a
                      className="navUser-action cart-button--primary"
                      data-cart-preview
                      data-dropdown="cart-preview-dropdown"
                      onClick={handleWishClick}
                      href="#"
                      aria-label="Cart with 0 items"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="cart-button"
                        style={{
                          display: "flex",
                          margin: "0px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg width={16} height={16}>
                          <use href="#icon-shopping-cart" />
                          <FaRegHeart size={16} />
                        </svg>
                      </div>
                      <p
                        className="cart-text text-shopping-cart"
                        style={{ textAlign: "center", color: "#93979c" }}
                      >
                        Wishlist
                      </p>
                    </a>
                    <div
                      className="dropdown-menu"
                      id="cart-preview-dropdown"
                      data-dropdown-content
                      aria-hidden="true"
                    />
                  </li>
                  <li className="navUser-item header-center__cart">
                    <a
                      className="navUser-action cart-button--primary"
                      data-cart-preview
                      data-dropdown="cart-preview-dropdown"
                      onClick={handleCartClick}
                      href="#"
                      aria-label="Cart with 0 items"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="cart-button" style={{ margin: "0px",position:"relative" }}>
                        <svg width={16} height={16}>
                          <use href="#icon-shopping-cart" />
                          <BsCart3 size={16} />
                        </svg>
                         {cartItemsCount > 0 && (
                          <span
                            style={{
                              position: "absolute",
                              top: "-1px",
                              right: "-2px",
                              backgroundColor: "red",
                              color: "white",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "13px",
                              fontWeight: "bold",
                            }}
                          >
                            {cartItemsCount}
                          </span>
                        )}
                      </div>
                      <p
                        className="cart-text text-shopping-cart"
                        style={{ textAlign: "center", color: "#93979c" }}
                      >
                        My Cart
                      </p>
                    </a>
                    <div
                      className="dropdown-menu"
                      id="cart-preview-dropdown"
                      data-dropdown-content
                      aria-hidden="true"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
